// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Checkmark: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 53"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M41.6 18c-.6-.5-1.5-.5-2.1 0L21.9 35.7l-8-8.1c-.3-.3-.7-.5-1.1-.5-.4 0-.8.2-1.1.5-.3.3-.5.7-.4 1.1 0 .4.2.8.5 1.1l9 8.9c.3.3.7.5 1.1.5h.3c.4 0 .8-.2 1.1-.5l18.5-18.5c.3-.3.4-.7.4-1.1-.1-.4-.2-.8-.6-1.1z"/><path d="M26.5.6C12.2.6.6 12.2.6 26.5s11.6 25.9 25.9 25.9 25.9-11.6 25.9-25.9S40.8.6 26.5.6zm0 49.2c-12.9 0-23.3-10.5-23.3-23.3S13.6 3.2 26.5 3.2s23.3 10.5 23.3 23.3-10.4 23.3-23.3 23.3z"/></svg>;
};

export default React.memo(Checkmark);
